import { StructuredDataProps } from '@nrdy-marketing-engine/structured-data';

export default function useHotmathStructuredData(
  slug: string,
  title: string
): StructuredDataProps[] {
  return [
    {
      '@type': 'BreadcrumbList',
      name: 'Hotmath navigation',
      itemListElement: [
        {
          '@type': 'ListItem',
          name: 'Home',
          position: 1,
          item: process.env.NEXT_PUBLIC_VT_WWW_ENDPOINT,
        },
        {
          '@type': 'ListItem',
          name: 'Hotmath',
          position: 2,
          item: `${process.env.NEXT_PUBLIC_VT_WWW_ENDPOINT}/hotmath`,
        },
        {
          '@type': 'ListItem',
          name: title,
          position: 3,
          item: `${process.env.NEXT_PUBLIC_VT_WWW_ENDPOINT}/hotmath/${slug}`,
        },
      ],
    },
  ];
}
